import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/internal/auth';

export class AuthServiceInternal implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async startZitadelAuthorizationRequest(
    params: types.StartZitadelAuthorizationRequestParameters,
  ): Promise<types.ZitadelAuthorizationRequestResponse> {
    const { data } = await this.axios.post<types.ZitadelAuthorizationRequestResponse>(
      `/auth/zitadel/authorization-request`,
      params.body,
    );
    return data;
  }
}
